<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">{{title}}</span>
    <!-- <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span> -->
</div>
<div *ngIf="step === 1" class="w-100 d-flex justify-content-center align-items-center">
  <div class=" d-flex flex-column align-items-center justify-content-center" style="width: 80%;">
    
    <span class="fs-18px  w-100" style="font-weight: bold; margin: 12px 0; text-align: justify;">Hola {{getUsuario()}}, ¿En que sucursal te encuentras el día de hoy?</span>
    <form [formGroup]="sucursalForm" class="example-form w-100">
      <input type="text"
        placeholder="Selecciona la Sucursal en la que te ubicas el día de hoy."
        [formControl]="controlSucursal"
        [matAutocomplete]="auto"
        class="form-control fs-14px">

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySucursal">
        <mat-option *ngFor="let sucursal of filteredSucursales | async" [value]="sucursal">
          {{ sucursal.nombreSucursal }}
        </mat-option>
      </mat-autocomplete>

    </form>
    
    <div class="w-100 d-flex flex-row justify-content-around align-items-center mt-2">
      <button class="btn btn-secondary" (click)="closeDialogCancel()">Regresar</button>
      <button class="btn btn-primary" [disabled]="getDisabledSeleccion()" (click)="guardar()">Guardar Selección</button>
    </div>
    <br><br>
  </div>
</div>

<div *ngIf="step === 2" class="w-100 d-flex justify-content-center align-items-center">
  <div class=" d-flex flex-column align-items-center justify-content-center" style="width: 80%;">
    <span class="mt-2">Toma una fotografía clara de <b>Tacometro</b></span>

    <div class="col-12">
      <!-- <span class="fs-14px font-weight-bold">Área dañada</span> -->
      <app-webcam (imageCaptured)="onImage($event)" [opcion]="1" (capturaReiniciada)="desactivarContinuar($event)" (camaraReady)="camaraInicializada($event)"></app-webcam>
      <span class="fs-14px font-weight-bold">Kilometraje</span>
      <input class="form-control" placeholder="Ingresa Kilometraje del auto" [(ngModel)]="kilometraje"  formatearMiles type="text" inputmode="numeric" (keydown)="limpiarCaracteresNoNumericos($event)" (keypress)="soloNumeros($event)"/>
    
    </div>

    <div class="w-100 d-flex flex-row justify-content-around align-items-center mt-2">
      <button class="btn btn-secondary" (click)="closeDialogCancel()">Regresar</button>
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="validarKilometraje()">Validar Kilometraje</button>
    </div>
    <br><br>
  </div>
</div>